import { Field, withFormik } from 'formik';
import React from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { InputSelect } from '../../components';
import { debounceIndexJobManagementsRequest } from '../../requests/jobManagements';
import { debounceIndexCostCentersRequest } from '../../requests/costCenters';
import { debounceIndexBranchOfficesRequest } from '../../requests/branchOffices';
import { debounceIndexSubsidiariesRequest } from '../../requests/subsidiaries';

const Filters = ({ setFieldValue }) => {
  const dispatch = useDispatch();
  const resultFetchData = response => {
    const { data } = response.data;
    const tempArray = data.map(element => {
      return {
        label: element.name,
        value: element.id
      };
    });
    return tempArray;
  };

  const fetchJobManagments = (inputValue, callback) => {
    debounceIndexJobManagementsRequest({
      dispatch,
      params: {
        actives: true,
        name: inputValue,
        sort_column: 'name',
        paginate: false
      },
      successCallback: data => {
        callback(resultFetchData(data));
      }
    });
  };

  const fetchCostCenters = (inputValue, callback) => {
    debounceIndexCostCentersRequest({
      dispatch,
      params: {
        actives: true,
        query: inputValue,
        sort_column: 'name',
        display_length: 100
      },
      successCallback: data => callback(resultFetchData(data))
    });
  };

  const fetchBranchOffices = (inputValue, callback) => {
    const request = async () => {
      debounceIndexBranchOfficesRequest({
        dispatch,
        params: {
          actives: true,
          name: inputValue,
          sort_column: 'name',
          paginate: false
        },
        successCallback: data => {
          callback(resultFetchData(data));
        }
      });
    };
    request();
  };

  const fetchSubsidiaries = (inputValue, callBack) => {
    debounceIndexSubsidiariesRequest({
      dispatch,
      params: {
        actives: true,
        sort_column: 'name',
        display_length: 500
      },
      successCallback: data => {
        callBack(resultFetchData(data));
      }
    });
  };

  return (
    <Accordion defaultActiveKey="1" className="col-12 p-0">
      <Col className="top-header-green settlement__filters">
        <Accordion.Toggle as={Col} eventKey="0" className="card-header-title justify-content-center">
          FILTROS DE BÚSQUEDA
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="0">
        <Card.Body className="">
          <Row>
            <Col xs={12} md={3}>
              <Field name="filterCostCenter">
                {({ field }) => (
                  <InputSelect
                    {...field}
                    label="Centro de costo"
                    placeholder="Seleccionar centro de costo"
                    request={fetchCostCenters}
                    value={undefined}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    isClearable
                  />
                )}
              </Field>
            </Col>
            <Col xs={12} md={3}>
              <Field name="filter_branch_offices">
                {({ field }) => (
                  <InputSelect
                    {...field}
                    label="Lugar de Prestación de Servicio"
                    placeholder="Seleccionar Lugar de Prestación"
                    request={fetchBranchOffices}
                    value={undefined}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    isClearable
                  />
                )}
              </Field>
            </Col>
            <Col xs={12} md={3}>
              <Field name="filterJobManagement">
                {({ field }) => (
                  <InputSelect
                    {...field}
                    label="Área"
                    placeholder="Seleccionar área"
                    request={fetchJobManagments}
                    value={undefined}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    isClearable
                  />
                )}
              </Field>
            </Col>
            <Col xs={12} md={3}>
              <Field name="subsidiaryId">
                {({ field }) => (
                  <InputSelect
                    {...field}
                    label="Sucursal"
                    placeholder="Seleccionar sucursal"
                    request={fetchSubsidiaries}
                    value={undefined}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    isClearable
                  />
                )}
              </Field>
            </Col>
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Accordion>
  );
};

const handleSubmit = (values, { props }) => {
  const { formRequest } = props;
  formRequest(values);
};

export default withFormik({
  mapPropsToValues: () => ({
    filterJobManagement: '',
    filter_branch_offices: '',
    filterCostCenter: '',
    filterBalanceIds: '',
    filterPeriodType: '',
    filterEmployeeIds: ''
  }),
  handleSubmit,
  enableReinitialize: true
})(Filters);
